// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2egHL","loaderOuter":"PageOverlayLoader_loaderOuter__2GOor"};